'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FORMAT_MAP = undefined;

var _luxon = require('luxon');

var FORMAT_MAP = exports.FORMAT_MAP = {
  short: 'dd MMM',
  medium: 'dd MMM yyyy',
  long: 'EEE, dd MMM yyyy',
  time: 'HH:mm',
  timezone: '(\'UTC\'ZZ)'
};

exports.default = function (formatStr) {
  return function (date) {
    return _luxon.DateTime.fromJSDate(date).toFormat(formatStr);
  };
};